'use client'

import OutletCard from '@/components/cards/OutletCard'
import Select from '@/components/ui/select'
import { useRouter, useSearchParams } from 'next/navigation'

const OutletsFeed = ({ initialOutlets }) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const outlets = initialOutlets || []
  const bias = searchParams.get('bias') || ''
  const reliability = searchParams.get('reliability') || ''
  const access = searchParams.get('access') || ''
  const sort = searchParams.get('sort') || 'alphabetical'

  const updateSearchParams = (key, value) => {
    const params = new URLSearchParams(searchParams)
    if (value) {
      params.set(key, value)
    } else {
      params.delete(key)
    }
    router.push(`/sources?${params.toString()}`)
  }

  const biasOptions = [
    { slug: '', name: 'All' },
    { slug: 'far-left', name: 'Far Left' },
    { slug: 'left', name: 'Left' },
    { slug: 'leans-left', name: 'Leans Left' },
    { slug: 'center', name: 'Center' },
    { slug: 'leans-right', name: 'Leans Right' },
    { slug: 'right', name: 'Right' },
    { slug: 'far-right', name: 'Far Right' },
  ]

  const reliabilityOptions = [
    { slug: '', name: 'All' },
    { slug: 'reliable', name: 'Reliable' },
    { slug: 'mostly-reliable', name: 'Mostly Reliable' },
    { slug: 'somewhat-reliable', name: 'Somewhat Reliable' },
    { slug: 'unreliable', name: 'Unreliable' },
  ]

  const sortOptions = [
    { slug: 'alphabetical', name: 'A-Z' },
    { slug: 'more-reliable', name: 'Reliability (High to Low)' },
    { slug: 'less-reliable', name: 'Reliability (Low to High)' },
    { slug: 'left', name: 'Bias (Left to Right)' },
    { slug: 'right', name: 'Bias (Right to Left)' },
  ]

  const accessOptions = [
    { slug: '', name: 'All' },
    { slug: 'free', name: 'Free' },
    { slug: 'limited', name: 'Limited' },
    { slug: 'paid', name: 'Paid' },
  ]

  // Filter outlets by access client-side if needed
  const filteredOutlets = access
    ? outlets.filter((outlet) => outlet.access?.toLowerCase() === access)
    : outlets

  return (
    <div>
      {/* Filters */}
      <div className="pb-6 mb-8 border-b border-border">
        <div className="flex flex-col sm:flex-row justify-center items-stretch sm:items-center gap-3 overflow-x-auto">
          <Select
            labelFor="sort"
            value={sort}
            onChange={(e) => updateSearchParams('sort', e.target.value)}
            options={sortOptions}
            className="text-sm flex-shrink-0"
          />
          <Select
            labelFor="bias"
            value={bias}
            onChange={(e) => updateSearchParams('bias', e.target.value)}
            options={biasOptions}
            className="text-sm flex-shrink-0"
          />
          <Select
            labelFor="reliability"
            value={reliability}
            onChange={(e) => updateSearchParams('reliability', e.target.value)}
            options={reliabilityOptions}
            className="text-sm flex-shrink-0"
          />
          <Select
            labelFor="access"
            value={access}
            onChange={(e) => updateSearchParams('access', e.target.value)}
            options={accessOptions}
            className="text-sm flex-shrink-0"
          />
        </div>
      </div>

      {/* Results */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredOutlets.length === 0 ? (
          <div className="col-span-full text-center py-12">
            <p className="font-serif text-base text-muted-foreground italic">
              No outlets found matching your filters.
            </p>
          </div>
        ) : (
          filteredOutlets.map((outlet) => (
            <OutletCard key={outlet.slug} outlet={outlet} />
          ))
        )}
      </div>
    </div>
  )
}

export default OutletsFeed
